import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Modal,
  TextField,
  Button,
  Divider,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

const LabReport = (props) => {
  const { investigations } = props;
  console.log(investigations);
  const [data, setData] = useState(investigations);

  const [editData, setEditData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openEditModal = (item) => {
    setEditData(item);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditData(null);
  };

  const handleSave = () => {
    setModalOpen(false);
    // Save changes logic here
  };

  return (
    <Box padding={4} sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <Typography
        variant="h6"
        gutterBottom
        align="center"
        sx={{ color: "#3f51b5", fontWeight: "bold" }}
      >
        Lab Report Overview
      </Typography>
      {data.map((investigation, index) => (
        <Card
          key={index}
          sx={{
            marginBottom: 3,
            boxShadow: 3,
            transition: "transform 0.3s",
            "&:hover": { transform: "scale(1.02)" },
          }}
        >
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                {investigation.name}
              </Typography>
            }
            sx={{
              background: "#0096c7",
              color: "white",
            }}
          />
          {investigation.method && (
            <Chip sx={{ m: 1, mb: 0 }} label={investigation.method.method} />
          )}
          <CardContent>
            {investigation.method && (
              <>
                <TableContainer>
                  <Table sx={{ border: "1px solid #ddd" }}>
                    <TableHead sx={{ backgroundColor: "#e3f2fd" }}>
                      <TableRow>
                        <TableCell>Age Range</TableCell>
                        <TableCell>Gender</TableCell>
                        <TableCell>Min</TableCell>
                        <TableCell>Max</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {investigation.method.ranges.map((range, rIndex) => (
                        <TableRow key={rIndex} hover>
                          <TableCell>{range.ageRange}</TableCell>
                          <TableCell>{range.gender}</TableCell>
                          <TableCell>{range.min}</TableCell>
                          <TableCell>{range.max}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}

            {investigation.subInvestigations.length > 0 && (
              <>
                {investigation.subInvestigations.map((sub, subIndex) => (
                  <Accordion key={subIndex}>
                    <AccordionSummary
                      sx={{ background: "#caf0f8" }}
                      expandIcon={<ExpandMoreIcon />}
                    >
                      <Typography textAlign={"center"}>
                        {sub.subInvestigationName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {/* <Typography variant="body2">
                        Method: {sub.method}
                      </Typography> */}
                      <Chip sx={{ mb: 1 }} label={sub.method} />
                      <TableContainer>
                        <Table sx={{ border: "1px solid #ddd" }}>
                          <TableHead sx={{ backgroundColor: "#e3f2fd" }}>
                            <TableRow>
                              <TableCell>Age Range</TableCell>
                              <TableCell>Gender</TableCell>
                              <TableCell>Min</TableCell>
                              <TableCell>Max</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {sub.ranges.map((range, rIndex) => (
                              <TableRow key={rIndex} hover>
                                <TableCell>{range.ageRange}</TableCell>
                                <TableCell>{range.gender}</TableCell>
                                <TableCell>{range.min}</TableCell>
                                <TableCell>{range.max}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </>
            )}
          </CardContent>
        </Card>
      ))}

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: 4,
            boxShadow: 24,
            width: 400,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Edit Investigation
          </Typography>
          <TextField
            label="Name"
            fullWidth
            margin="normal"
            value={editData?.name || ""}
            onChange={(e) => setEditData({ ...editData, name: e.target.value })}
          />
          <Box display="flex" justifyContent="flex-end" gap={2} marginTop={2}>
            <Button
              variant="outlined"
              onClick={handleCloseModal}
              startIcon={<CloseIcon />}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default LabReport;
